import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Badge, Button, Modal, Table } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';



export default function DataGridLastTdHook({ item, props, entity = null }) {

    const [statusModal, setStatusModal] = useState(null)
    const [statusModalRequest, setStatusModalRequest] = useState(null)
    const [countRequest, setCountRequest] = useState(null)
    const [listSource, setListSource] = useState([])
    const [dataDetails, setDataDetails] = useState(null)
    const navigate = useNavigate()
    const [isSending, setIsSending] = useState(false)
    const [showConfirmSend, setShowConfirmSend] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)


    useEffect(() => {
    }, []);

    function openModal() {
        getJobRequest()
    }

    function closeModal() {
        setStatusModal(false)
    }

    function openModalRequest() {
        getDetails()
    }

    function closeModalRequest() {
        setStatusModalRequest(false)
    }

    async function getJobRequest() {
        var constraints = [{ fieldName: "idJobPost", type: "value", value: item.id }];
        var sorting = {
            'field': "id",
            'order': "desc"
        }
        var res = await DataManager.searchItems('job_request', 1, 10000, sorting, '', [], constraints)
        if (res.success === 1) {
            var items = res.body
            const result = Object.entries(
                items.reduce((acc, item) => {
                    const key = item.source.value;
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {})
            ).map(([name, value]) => ({ name, value }));
            console.log(result)
            setCountRequest(items.length)
            setListSource(result)
            setStatusModal(true)
        }
    }


    async function getDetails() {
        navigate('/page/Candidates?id=' + item.id)
    }


    function openSendConfirm() {
        setShowConfirmSend(true)
    }

    function closeSendConfirm() {
        if (!isSending) {
            setShowConfirmSend(false)
        }
    }

    async function sendEmail() {
        if (isSending) return;
        setShowConfirmSend(false);
        setIsSending(true);
        const toastId = toast.loading('Invio email in corso...', { theme: 'colored' });
        try {
            const body = { idJobPost: item.id };
            const res = await ApiManager.sendAuthenticatedRequest('/custom/notify_applicants', body);
            if (res && res.success === 1) {
                toast.update(toastId, { render: 'Email inviate con successo.', type: 'success', isLoading: false, autoClose: 3000 });
            } else {
                const msg = (res && res.message) ? res.message : 'Errore durante l\'invio delle email.';
                toast.update(toastId, { render: msg, type: 'error', isLoading: false, autoClose: 4000 });
            }
        } catch (e) {
            toast.update(toastId, { render: 'Errore di rete durante l\'invio.', type: 'error', isLoading: false, autoClose: 4000 });
        } finally {
            setIsSending(false);
        }
    }



    const DELETE_USER_ENDPOINT = '/custom/hard_delete_user';

    function openDeleteConfirm() {
        setShowConfirmDelete(true)
    }

    function closeDeleteConfirm() {
        if (!isDeleting) {
            setShowConfirmDelete(false)
        }
    }

    async function deleteUser() {
        if (isDeleting) return;
        setIsDeleting(true);
        const toastId = toast.loading('Eliminazione utente in corso...', { theme: 'colored' });
        try {
            const body = { id: item.id };
            const res = await ApiManager.sendAuthenticatedRequest(DELETE_USER_ENDPOINT, body);
            if (res && res.success === 1) {
                toast.update(toastId, { render: 'Utente eliminato definitivamente.', type: 'success', isLoading: false, autoClose: 3000 });
                setShowConfirmDelete(false);
                window.location.reload();
            } else {
                const msg = (res && res.message) ? res.message : 'Errore durante l\'eliminazione dell\'utente.';
                toast.update(toastId, { render: msg, type: 'error', isLoading: false, autoClose: 4000 });
            }
        } catch (e) {
            toast.update(toastId, { render: 'Errore di rete durante l\'eliminazione.', type: 'error', isLoading: false, autoClose: 4000 });
        } finally {
            setIsDeleting(false);
        }
    }

    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'user': return (
                            <>
                                <Button
                                    variant='outline-danger'
                                    className='ms-1'
                                    size='sm'
                                    onClick={() => openDeleteConfirm()}
                                    disabled={isDeleting}
                                >
                                    <FontAwesomeIcon icon={'trash'} className='me-1'></FontAwesomeIcon>
                                    Elimina definitivamente
                                </Button>

                                <Modal show={showConfirmDelete} onHide={closeDeleteConfirm}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Elimina utente definitivamente</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Stai per eliminare <strong>definitivamente</strong> l'utente. L'operazione non è reversibile. Vuoi procedere?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant='secondary' onClick={closeDeleteConfirm} disabled={isDeleting}>
                                            Annulla
                                        </Button>
                                        <Button variant='danger' onClick={deleteUser} disabled={isDeleting}>
                                            Elimina definitivamente
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </>
                        );
                        case 'job_post': return (
                            <>
                                <Button variant='primary' className='ms-1' size='sm' onClick={() => openModal()}>Statistiche</Button>
                                <Button variant='outline-primary' className='ms-1' size='sm' onClick={() => openModalRequest()}>Candidati</Button>
                                <Button
                                    variant='outline-secondary'
                                    className='ms-1'
                                    size='sm'
                                    onClick={() => openSendConfirm()}
                                    disabled={isSending}
                                >
                                    <FontAwesomeIcon icon={'envelope'}></FontAwesomeIcon>
                                </Button>

                                <Modal show={statusModal} onHide={closeModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Richieste ricevute: {countRequest}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {listSource ? <>
                                            <h4>Elenco fonte richiesta</h4>
                                            <Table striped bordered>
                                                <thead>
                                                    <tr>
                                                        <th>Fonte</th>
                                                        <th>Numero candidati</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listSource && listSource.map((item, i) => {
                                                        return (<>
                                                            <tr key={i}>
                                                                <td>{item.name === "10_AGENCY" ? "Agenzia" : (item.name === "0_WEBSITE" ? "Sito Web" : (item.name === "20_LINKEDIN" ? "Linkedin" : ""))}</td>
                                                                <td>{item.value}</td>
                                                            </tr>
                                                        </>)
                                                    })}
                                                </tbody>
                                            </Table>
                                        </> : null}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={closeModal}>
                                            Chiudi
                                        </Button>
                                    </Modal.Footer>
                                </Modal>




                                <Modal show={statusModalRequest} onHide={closeModalRequest}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Richieste ricevute: {countRequest}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {dataDetails ? <>
                                            <h4>Elenco candidati</h4>
                                            <Table striped bordered>
                                                <thead>
                                                    <tr>
                                                        {dataDetails && dataDetails.questions.map((item) => {
                                                            return (<>
                                                                <td>{item.title}</td>
                                                            </>)
                                                        })}
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        {dataDetails && dataDetails.answers.map((item) => {
                                                            return (<>
                                                                <td>{item.answer}</td>
                                                            </>)
                                                        })}
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </> : null}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={closeModalRequest}>
                                            Chiudi
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal show={showConfirmSend} onHide={closeSendConfirm}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Invio email ai candidati</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Stai per inviare una comunicazione ai candidati con "Proposta inviata" = NO. Vuoi procedere?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant='secondary' onClick={closeSendConfirm} disabled={isSending}>
                                            Annulla
                                        </Button>
                                        <Button variant='primary' onClick={sendEmail} disabled={isSending}>
                                            Conferma invio
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
